import styled from 'styled-components'
import { useRouter } from 'next/router'

import Text from '@/components/atomic/atoms/Text'
import theme from '@/theme'
import { generateTagId } from '@/utils/test-automation'

interface WrapperProps {
  $image?: string
}
const Wrapper = styled.div<WrapperProps>`
  height: 333px;
  position: relative;
  box-sizing: border-box;
  background-image: url('${(props: WrapperProps) => props.$image}');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center top;

  .text-box {
    width: 100%;
    height: 104px;
    text-align: center;
    position: absolute;
    bottom: 0px;
    box-sizing: border-box;
    padding: 0 ${theme.variables.contentMargin}px;
    height: 100px;
  }
  .text-box-inner {
    width: 100%;
    max-width: 100vw;
    background-color: #ffffff;
    margin: 0 auto;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .text-box h1 {
    font-size: 16px;
    font-weight: 500;
    line-height: 1.5;
    margin: 8px 32px;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-stretch: normal;
    font-style: normal;
  }
  .text-box p {
    font-size: 12px;
    line-height: 1.33;
    color: #9b9b9b;
    margin: 0px;
  }
`

interface Props {
  post: Post
  onClickTag?: (tag: string) => void
}

const PostInfoCard: React.FC<Props> = (props: Props) => {
  const { authorId, date } = props.post
  const router = useRouter()

  return (
    <Wrapper $image={props.post.thumbnailUrl}>
      <div className="text-box">
        <div className="text-box-inner">
          <h1 id={generateTagId('column', 'page', 'text', 'title', 'top')}>{props.post.title}</h1>
          <StyledTagList>
            {props.post.tag.map((tag) => (
              <StyledTag
                key={tag}
                onClick={() => {
                  props.onClickTag?.(tag)
                  void router.push(`/tags/${tag}`)
                }}
              >{`#${tag}`}</StyledTag>
            ))}
          </StyledTagList>
          <StyledMetaInfo>
            <StyledText type="caption2">
              {authorId} | {date}
            </StyledText>
          </StyledMetaInfo>
        </div>
      </div>
    </Wrapper>
  )
}

const StyledTagList = styled.p`
  a {
    text-decoration: none;
  }
`

const StyledTag = styled.span`
  margin-right: 5px;
  color: ${({ theme }) => theme.colors.gray800};
  cursor: pointer;
`
const StyledMetaInfo = styled.div``
const StyledText = styled(Text)`
  color: ${({ theme }) => theme.colors.gray800};
`

export default PostInfoCard
